<template>
  <div id="app">
    <data-screen />
  </div>
</template>

<script>
import DataScreen from './views/DataScreen.vue'

export default {
  name: 'App',
  components: {
    DataScreen
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}
</style> 